import { Component, ErrorInfo, ReactNode } from "react";
import { logger } from "../../services/logger";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * Wraps the app root. Catches render-time crashes React would otherwise
 * unmount the whole tree for, logs them, and shows a minimal recovery UI
 * instead of a blank white screen.
 */
class GlobalErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logger.reactError({
      message: error.message,
      stack: error.stack,
      component_stack: errorInfo.componentStack,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            gap: "12px",
            fontFamily: "sans-serif",
          }}
        >
          <h2>Something went wrong.</h2>
          <button onClick={() => window.location.reload()}>Reload</button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default GlobalErrorBoundary;
